module.exports = __webpack_public_path__ + "img/logo_small.a7ee6fca.png";